import Swiper, { Navigation, Pagination } from 'swiper';
//require('fslightbox');
import {MDCDialog} from '@material/dialog';
const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));

Swiper.use([Navigation, Pagination]);

var productGallery = new Swiper(
  '.single-product-page__container__product__gallery__wrapper__container__slider',
  {
    spaceBetween: 15,
    pagination: {
      el:
        '.single-product-page__container__product__gallery__wrapper__container__slider__pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return `<span>${current}</span> z <span>${total}</span>`;
      },
    },

    navigation: {
      nextEl:
        '.single-product-page__container__product__gallery__wrapper__container__slider__next',
      prevEl:
        '.single-product-page__container__product__gallery__wrapper__container__slider__prev',
    },
  }
);

const wrapper = document
.querySelector(
  '.single-product-page__container__product__gallery__wrapper__bottom__left a'
)

if (wrapper) {
  wrapper
    .addEventListener('click', () => {
      document.querySelectorAll('.single-product-page__container__product__gallery__wrapper__container__slider__item a')[productGallery.realIndex]
        .dispatchEvent(new Event('click'))
  });
}

const pattern_buttons = document.querySelectorAll('.pattern_img');
pattern_buttons.forEach(b => {
  b.addEventListener('click', function() {
    dialog.open()
  })
})
